module.exports = __webpack_public_path__ + "img/rapa-nui.1ea74d28.svg";